<template>
  <div id="nav-template" class="sticky-top">
    <nav>
        <div class="brand-text">
            <router-link :to="{ path: '/'}">
                <span class="blue">F</span><span class="purple">o</span><span class="red">o</span><span class="yellow">d</span>
                <span class="blue">F</span><span class="green">i</span><span class="purple">g</span><span class="maroon">h</span><span class="blue">t</span><span class="green">s</span>
                <span class="version-tag">Alpha.v0.1 - Nebulas</span>
            </router-link>
        </div>
        
        <span class="brand-subtext">
            "{{ 'MAIN_TAGLINE' | translate }}"
        </span>

        <div v-if="pendingTransaction" class="transaction-loader">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            <sub>{{ 'PENDING_TRANSACTION' | translate }}</sub>
        </div>

        <!--
        <b-button-group class="translation-btn" size="sm">
            <b-button :class="{ selected: locale == 'en' }" @click="updateLocale('en')">EN</b-button>
            <b-button :class="{ selected: locale == 'cn' }" @click="updateLocale('cn')">CN</b-button>
        </b-button-group>     
        -->

        <b-dropdown id="ddown1" right :text="$t('ACCOUNT')" class="m-md-2">
            <b-dropdown-item @click="goToRoute('home')">
                {{ 'HOME' | translate }}
            </b-dropdown-item>
            <b-dropdown-item @click="goToRoute('profile', address)">
                {{ 'MY_PROFILE' | translate }}
            </b-dropdown-item>
            <b-dropdown-item @click="goToRoute('leaderboard')">
                {{ 'LEADERBOARDS' | translate }}
            </b-dropdown-item>
        </b-dropdown>

        <div class="row justify-content-center mt-3 mb-3">
            <div class="col-md-5 text-center">
                <div v-if="!address">
                    <input type="text" class="form-control address" v-model="newAddress" placeholder="Add Primary Address">
                    <button @click="saveAddress" class="btn btn-primary ml-2">Save</button>
                </div>
                <div v-else>
                    <span>
                        {{ address }}
                    </span>
                    <i @click="removeAddress" class="fas fa-trash-alt remove-icon"></i>
                </div>        
            </div>       
        </div>
    </nav>
    <div v-if="hasError.status" class="alert alert-warning" role="alert">
        <div v-html="$t('NEBULAS_ERROR')"></div>
        <div>
            {{ 'ERROR_MESSAGE' | translate }}: {{ hasError.message }}
        </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { getCardScore } from "../../util/transformDna";

export default {
    name: 'the-top-nav',
    methods: {
        viewCard (card) {
            this.$root.$emit('bv::show::modal','card-view-modal');
            this.$store.commit('setCard', card);
        },
        constructCardFromDna (card) {
            let power = {};
            return power;
        },
        getCardScore (card) {
            return getCardScore(card);
        },
        saveAddress () {
            this.$store.commit('setUser', { address: this.address });
            this.$store.commit('updateUserCards', { address: this.address });
        },
        resetAddress () {
            this.$store.commit('resetUser');
            this.$store.commit('resetUserCards');
        },
        updateLocale (locale) {
            
            this.$store.commit('setLocale', { locale });
            
            // Set in module
            this.$i18n.set(locale);

        },

        saveAddress () {
            const address = this.newAddress;
            this.$store.commit('saveAddress', { address });

            // Restore users
            this.$store.commit('setUserGames', {});
        },

        removeAddress () {
            this.$store.commit('removeAddress');
            this.newAddress = '';

            // Reset users
            this.$store.commit('resetUserGames');
        },

         goToRoute (_name, _id) {

            if (name == 'game') {
                this.$store.commit('setGame', { id: _id });             
            } 

            this.$router.push({ name: _name, params: { id: _id }});

        }
        
    },
    data () {
        return {
            newAddress: null
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
            address: 'getAddress',
            hasError: 'getHasError',
            hasExtension: 'getHasExtension',
            pendingTransaction: 'getPendingTransaction'
        })
    }
}
</script>

<style scoped lang="less">
@backgroundColor: #54657A;
@navFontFamily: 'Bubblegum Sans', cursive;

.alert {
    text-align: center;
    margin-bottom: 0;
    border-radius: 0;
}

.purple {
    color: #B98CF6;
}

.red {
    color: #E871CB;
}

.yellow {
    color: #FFD900;
}

.green {
    color: #66F04D;
}

.blue {
    color: #BCEFF8;
}

.maroon {
    color: #FF7842;
}

nav {

    .transaction-loader {
        position: absolute;
        top: 55px; left: 26px;

        sub {
            font-size: 13px;
            color: #ccc;
        }
    }

    .form-control.address {
        display: inline-block;
        border-radius: 0;
        width: 80%;
    }

    .remove-icon {
        cursor: pointer;
    }

    .translation-btn {
        position: absolute;
        top: 32px; right: 150px;
    }

    .form-control {
        border-radius: 0;
    }

    .address-header {
        width: 400px;
        position: relative;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;

        i {
            position: absolute;
            top: 8px;
            right: 10px;
        }
    }

    .brand-text {
        font-size: 42px;
        font-family: @navFontFamily;

        a {
            position: relative;
            color: #fff;

            &:hover {
                text-decoration: none;
            }
        }

        .version-tag {
            position: absolute;
            right: 0; top: -20px;
            font-size: 12px;
            color: #88929b;
        }
    }

    .brand-subtext {
        font-style: italic;
        font-size: 13px;
    }

    .card-counter {
        position: absolute;
        top: 25px;
        left: 30px;
        color: #ccc;
        font-size: 13px;
    }

    .version-text {
        position: absolute;
        top: 15px; right: 30px;
    }
}

// Tablet device
@media only screen and (max-width: 768px) {
    .card-counter, .transaction-loader {
        display: none;
    }
    .dropdown, .translation-button {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheTopNav.vue